import {getCountryCode} from '../CountryRestriction/CountryRestrictionUtility';

export class ContactPersonController {
  private readonly contactPersonSelector: string = '.js-contactPersonWrapper';

  public constructor() {
    const $contactPersonElement = $(this.contactPersonSelector);
    const $contactPersonForm = $contactPersonElement.find('form');
    const $contactPersonSelect = $contactPersonElement.find('.js-contactPersonSelect');
    const $contactPersonZipInput = $contactPersonElement.find('.js-zipInput');

    if ($contactPersonElement.length > 0 && $contactPersonForm && $contactPersonSelect) {
      $contactPersonForm.on('submit', (event) => {
        event.preventDefault();
        this.updateContact();
      });

      $contactPersonSelect.on('change', () => {
        this.updateContact();
      });

      $contactPersonZipInput.on('input', () => {
        this.updateContact();
      });

      // preselect country
      $contactPersonSelect.val(getCountryCode());
      $contactPersonSelect.trigger('change');
      this.updateContact();
    }
  }

  private updateContact() {
    const $selectedOption = $('.js-contactPersonSelect option:selected');
    const zipRangeMap: ZipRange[] = $selectedOption.data('mapping');
    const useZip = $selectedOption.data('zip');
    const countryCode = $selectedOption.val();
    const contactPerson = $selectedOption.data('contact');
    if (useZip) {
      let zipLength = 5;
      if (countryCode === 'ch') {
        zipLength = 4;
      }
      $('.js-contactPersonZip').removeClass('hide');
      let zip = $('.js-zipInput').val() || '0';
      if (typeof zip === 'string') {
        let inputLength = zip.length;
        if (zip.charAt(0) === '0') {
          zipLength = zipLength - 1;
          inputLength = inputLength - 1;
        }
        // fill unfinished input (input: 12 --> 12000) according to ZIP length
        zip = parseInt(zip, 10) * Math.pow(10, zipLength - inputLength);
      }
      for (const zipRange of zipRangeMap) {
        if (zip >= zipRange.min && zip <= zipRange.max) {
          this.showContactPerson(zipRange.contactPersonUid);
          return;
        }
      }
    } else {
      $('.js-contactPersonZip').addClass('hide');
      this.showContactPerson(contactPerson);
    }
  }

  private showContactPerson(id: number) {
    $('.js-contactPerson').addClass('hide');
    $('.js-contactPerson[data-id="' + id + '"]').removeClass('hide');
  }
}

export interface ZipRange {
  min: number;
  max: number;
  contactPersonUid: number;
}
